<template>
  <div class="home">
    <carousel
      :data="slides"
      lang="en"
      :class="this.$isPC ? '' : 'sp-carousel'"
      width="530"
      height="120"
    />
    <h1 style="color: rgb(26, 87, 167)">
      呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call
    </h1>
    <news />
    <campaign-contact v-if="this.$isPC" />
    <sp-campaign-contact v-else />
    <rental v-if="this.$isPC" />
    <sp-rental v-else />
    <sp-phone-contact v-if="!this.$isPC" />
    <choices :showAll="true" />
    <div class="columns" style="margin-top: 30px;">
      <label class="selected" style="cursor: default;">
        <h2>
          <div style="font-size: 26px;">お役立ち</div>
          <div style="font-size: 16px;">コラム</div>
        </h2>
      </label>
    </div>
    <div class="industry-scene-column-header for-in-home">
      <link-button
        v-bind:link="`/columns/`"
        v-bind:title="`詳細へ`"
        :style="this.$isPC ? '' : 'float: none;'"
      />
    </div>
    <div class="body">
      <div class="use-scene-block">
        <router-link to="/column/56">
          <div class="use-scene-block-header">
            店員が捕まらず購入を諦めるお客様がいるなら呼び出しベルの導入を
          </div>
        </router-link>
        <p>
          呼び出しベルには工事不要で設置できる製品も多く、お客様がスタッフを呼び出す以外にも、サービスの順番待ちをしているお客様の呼び出しにも活用できます。ホームセンターや家電量販店に向いた呼び出しベルについて解説します。
        </p>
      </div>
      <div class="use-scene-block">
        <router-link to="/column/55">
          <div class="use-scene-block-header">
            試着室からの呼び出しに気付けないなら呼び出しベル導入がおすすめ
          </div>
        </router-link>
        <p>
          試着室からの呼び出しに気付けない場合は、音だけでなく光や振動でも呼び出せる
        </p>
      </div>
      <div class="use-scene-block">
        <router-link to="/column/54">
          <div class="use-scene-block-header">
            「先生を呼びたいけど近くにいない」という悩みを解決する呼び出しベル
          </div>
        </router-link>
        <p>
          「先生を呼びたいけど近くにいない」と悩んでいる生徒を抱える学習塾や教育機関向けに、使いやすい呼び出しベルを紹介します。質問しやすい環境を作りたい方は、ぜひ参考にしてください。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueCarousel from '@chenfengyuan/vue-carousel'
import News from '@/components/modules/News'
import CampaignContact from '@/components/modules/campaign/CampaignContact'
import Rental from '@/components/modules/campaign/Rental'
import SpCampaignContact from '@/components/modules/campaign/SpCampaignContact'
import SpRental from '@/components/modules/campaign/SpRental'
import SpPhoneContact from '@/components/modules/campaign/SpPhoneContact'
import Choices from '@/components/modules/choice/Choices'
import '../../js/modernizr-custom'

Vue.component(VueCarousel.name, VueCarousel)

export default {
  components: {
    News,
    CampaignContact,
    Rental,
    SpCampaignContact,
    SpRental,
    SpPhoneContact,
    Choices,
  },
  title: '呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call',
  meta:
    '呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call。飲食店、工場、病院等で活用。フォームお見積りキャンペーンやデモ機の1週間無料レンタルも行なっております、まずはお試しから可能となっております。',
  canonical:
    '呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call。飲食店、工場、病院等で活用。フォームお見積りキャンペーンやデモ機の1週間無料レンタルも行なっております、まずはお試しから可能となっております。',
  data() {
    return {
      slides: [
        '<div class="carousel-slide slide1"><div class="front-slide front1"></div></div>',
        '<div class="carousel-slide slide2"></div>',
        '<div class="carousel-slide slide3"></div>',
        '<div class="carousel-slide slide4"></div>',
        '<div class="carousel-slide slide5"><div class="front-slide front5"></div></div>',
      ],
    }
  },
}
</script>

<style>
.carousel {
  width: 100%;
  max-width: 1400px;
}

.sp-carousel {
  max-height: 200px;
}

.carousel-slide {
  height: 500px;

  background-repeat: no-repeat;
  background-position: 50% 80%;
  background-size: cover;
}

.sp-carousel .carousel-slide {
  max-height: 150px;
}

.carousel-slide .front-slide {
  height: 100%;

  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain;
}

.sp-carousel .front-slide {
  max-height: 200px;
}

.carousel-slide.slide1 {
  background-image: url('../../assets/scene1.jpg');
  width: 100%;
  height: 500px;
}

.carousel-slide.slide2 {
  background-image: url('../../assets/slide2.png');
  width: 100%;
  height: 500px;
}

.carousel-slide.slide3 {
  background-image: url('../../assets/slide3.png');
  width: 100%;
  height: 500px;
}

.carousel-slide.slide4 {
  background-image: url('../../assets/slide4.png');
  width: 100%;
  height: 500px;
}

.carousel-slide.slide5 {
  background-image: url('../../assets/scene4.jpg');
  width: 100%;
  height: 500px;
}

.front-slide.front1 {
  background-image: url('../../assets/s1.png');
}

.front-slide.front5 {
  background-image: url('../../assets/s5.png');
}

.home .body {
  display: flex;
  justify-content: center;

  max-width: 960px;
  padding: 0 8px;

  @media only screen and (max-width: 600px) {
    flex-direction: column;
  }
}

.home .body .use-scene-block {
  align-self: flex-start;

  margin: 20px 15px;

  text-align: left;

  flex: 1;
}

.home .body .use-scene-block img {
  display: block;

  width: 100%;
  max-width: 420px;
  height: auto;
  margin: 10px auto;

  background-color: #eee;
}

.home .body .use-scene-block p {
  font-size: 12px;
  line-height: 22px;

  margin: 8px 0 0 0;
}

.home .body .use-scene-block .use-scene-block-header {
  font-size: 18px;
  font-weight: bold;
  line-height: 1.5;
  min-height: calc(1.5em * 3);

  padding-left: 10px;

  border-left: 4px solid rgb(45, 183, 68);

  @media only screen and (max-width: 600px) {
    min-height: auto;
  }
}

.columns {
  display: flex;
  justify-content: space-around;

  width: 50%;
  margin: 0 auto 30px;
}

.columns label {
  font-weight: bold;

  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  width: 120px;
  height: 120px;

  cursor: pointer;
  text-align: center;

  color: white;
  border-radius: 50%;
  background: rgb(35, 145, 235);
}

.columns label.selected {
  background: rgb(26, 87, 167);
}

.industry-scene-column-header {
  font-weight: bold;
  display: flex;
  justify-content: right;
  max-width: 960px;
  width: 100%;
  margin-right: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Home.vue